// import React, { lazy } from "react";
import { createBrowserRouter } from "react-router-dom";
import globalRouteObjectList from "./routeObjectList";
const globalRouter = createBrowserRouter(globalRouteObjectList);

export default globalRouter;
